import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-calendar-quarter-of-year-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(CalendarQuarterOfYearMultiSelectSearchControlComponent)
    ]
})
export class CalendarQuarterOfYearMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.common.calendar-quarter.1", value: "Q1"},
            {label: "wbo.common.calendar-quarter.2", value: "Q2"},
            {label: "wbo.common.calendar-quarter.3", value: "Q3"},
            {label: "wbo.common.calendar-quarter.4", value: "Q4"}
        ]);
    }
}
